import { render, staticRenderFns } from "./TestResult.vue?vue&type=template&id=c3f74540&scoped=true"
import script from "./TestResult.vue?vue&type=script&lang=js"
export * from "./TestResult.vue?vue&type=script&lang=js"
import style0 from "./TestResult.vue?vue&type=style&index=0&id=c3f74540&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3f74540",
  null
  
)

export default component.exports